import React, { useState, useEffect } from 'react';
import './App.css';
import BackgroundEffect from './BackgroundEffect';
import { collection, getDocs, doc, setDoc, deleteDoc } from 'firebase/firestore';
import { db } from './firebase';

const getIcon = (type) => {
  if (type === 'facebook') return (
    <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round">
      <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>
    </svg>
  );
  if (type === 'instagram') return (
    <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
      <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
      <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
    </svg>
  );
  if (type === 'correo') return (
    <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
      <polyline points="22,6 12,13 2,6"></polyline>
    </svg>
  );
  return (
    <svg viewBox="0 0 24 24" width="28" height="28" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path>
    </svg>
  );
};

const getLabel = (type) => {
  if (type === 'facebook') return 'Facebook';
  if (type === 'instagram') return 'Instagram';
  if (type === 'correo') return 'Correo';
  return 'WhatsApp';
};

function App() {
  const [buttons, setButtons] = useState([
    { id: 'default-wa', type: 'whatsapp', link: 'https://chat.whatsapp.com/IKF4i1hc1Zm1yLWuAHAXAr?mode=gi_t' }
  ]);
  const [isAdmin, setIsAdmin] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [newBtnType, setNewBtnType] = useState('facebook');
  const [newBtnLink, setNewBtnLink] = useState('');

  // Fetch buttons from Firebase on mount
  useEffect(() => {
    const fetchButtons = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "links"));
        const fetched = [];
        querySnapshot.forEach((doc) => {
          fetched.push({ id: doc.id, ...doc.data() });
        });
        if (fetched.length > 0) {
          setButtons(fetched.sort((a,b) => a.order - b.order));
        }
      } catch (error) {
        console.log("Firebase no configurado o sin datos aún. Usando botón por defecto.");
      }
    };
    fetchButtons();
  }, []);

  const handleLogin = (e) => {
    e.preventDefault();
    if (username === 'cocless-administradora' && password === 'Jose310599') {
      setIsAdmin(true);
      setShowLogin(false);
      setUsername('');
      setPassword('');
    } else {
      alert("Credenciales incorrectas");
    }
  };

  const handleAddButton = async () => {
    if (!newBtnLink) return alert("Por favor ingresa un link");
    const newId = Date.now().toString();
    let finalLink = newBtnLink.trim();
    if (!finalLink.startsWith('http://') && !finalLink.startsWith('https://')) {
      finalLink = 'https://' + finalLink;
    }

    if (newBtnType === 'whatsapp' && finalLink.includes('chat.whatsapp.com')) {
      // Clean other parameters and force ?mode=gi_t (Group Info mode)
      finalLink = finalLink.split('?')[0] + '?mode=gi_t';
    }

    const newBtn = {
      id: newId,
      type: newBtnType,
      link: finalLink,
      order: buttons.length
    };
    
    // Optimistic UI update
    setButtons([...buttons, newBtn]);
    setNewBtnLink('');

    try {
      await setDoc(doc(db, "links", newId), newBtn);
    } catch (e) {
      console.error(e);
      alert("⚠️ ALERTA: Firebase falló al guardar. El botón desaparecerá al recargar la página. Revisa tu configuración de Firebase o las Reglas de Firestore.");
    }
  };

  const handleDeleteButton = async (id) => {
    setButtons(buttons.filter(b => b.id !== id));
    try {
      await deleteDoc(doc(db, "links", id));
    } catch (e) {
      console.log("Firebase no configurado", e);
    }
  };

  return (
    <>
      <BackgroundEffect />
      <div className="landing-container">
        <nav className="navbar">
          <div className="logo-container">
            <img src="/logo-cocless.png" alt="Cocless Logo" className="navbar-logo" />
            <span className="navbar-brand">Cocless</span>
          </div>
          {!isAdmin ? (
            <button className="admin-login-btn" onClick={() => setShowLogin(true)}>Login</button>
          ) : (
            <button className="admin-login-btn" onClick={() => setIsAdmin(false)}>Salir</button>
          )}
        </nav>
        
        <main className="main-content">
          <div className="profile-section">
            <img src="/logo-cocless.png" alt="Profile" className="profile-image" />
            <h1 className="brand-title">SHEIN</h1>
          </div>

          <p className="subtitle">
            Únete a la comunidad de WhatsApp, dale clic al icono 👇🛍️🛒
          </p>
          
          <div className="buttons-list">
            {buttons.map((btn) => (
              <div key={btn.id} className="button-edit-wrapper">
                <a 
                  href={btn.link} 
                  className={`social-button btn-${btn.type}`}
                >
                  <div className="icon-wrapper">
                    {getIcon(btn.type)}
                  </div>
                  <span className="button-text">{getLabel(btn.type)}</span>
                </a>
                {isAdmin && (
                  <button className="delete-btn" onClick={() => handleDeleteButton(btn.id)}>X</button>
                )}
              </div>
            ))}
          </div>

          {isAdmin && (
            <div className="admin-panel">
              <h3>Agregar Botón</h3>
              <select value={newBtnType} onChange={(e) => setNewBtnType(e.target.value)}>
                <option value="whatsapp">WhatsApp</option>
                <option value="facebook">Facebook</option>
                <option value="instagram">Instagram</option>
                <option value="correo">Correo</option>
              </select>
              <input 
                type="text" 
                placeholder="Ingresar Link..." 
                value={newBtnLink}
                onChange={(e) => setNewBtnLink(e.target.value)}
              />
              <button onClick={handleAddButton}>AGREGAR BOTÓN</button>
            </div>
          )}
        </main>

        <footer className="footer">
          <span className="footer-brand">Cocless</span>
        </footer>
      </div>

      {showLogin && (
        <div className="modal-overlay" onClick={() => setShowLogin(false)}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <h3 style={{color: '#333'}}>Acceso Administradora</h3>
            <form onSubmit={handleLogin} style={{display: 'flex', flexDirection: 'column', gap: '12px'}}>
              <input 
                type="text" 
                placeholder="Usuario" 
                value={username}
                onChange={e => setUsername(e.target.value)}
              />
              <input 
                type="password" 
                placeholder="Contraseña" 
                value={password}
                onChange={e => setPassword(e.target.value)}
              />
              <button type="submit">Ingresar</button>
            </form>
          </div>
        </div>
      )}
    </>
  );
}

export default App;
